///<reference path='../../typings/index.d.ts' />
///<reference path='../config.ts' />

module agi.expressions.card.layer {
    import Config = agi.expressions.card.Config;
    import Event = agi.expressions.event.Event;
    import EventBus = agi.expressions.event.EventBus;

    export class DomLayer {
        protected container:HTMLElement;
        protected measuringContainer:HTMLElement;
        protected element:HTMLDivElement;
        protected eventBus:EventBus = EventBus.getInstance();

        constructor(container:HTMLElement, measuringContainer:HTMLElement){
            this.container = container;
            this.measuringContainer = measuringContainer;
        }

        public init(){
            //initialize the element
            this.element = document.createElement("div");
            this.container.appendChild(this.element);
        }

        public hide() {
            this.element.style.display = "none";
        }

        public show(){
            this.element.style.display = "block";
        }

        public resize(event:Event):void {
            //This is the square resize
            var innerHeightAdjustment = .95; //Add some padding for landscape
            var width = Config.SQUARE_SIZE;

            if (this.measuringContainer){
                width = this.measuringContainer.offsetWidth;
            }

            if (window.innerHeight < width) {
                width = window.innerHeight * innerHeightAdjustment;
            }

            var scale = width/Config.SQUARE_SIZE;

            this.element.style.transformOrigin = "0px 0px";
            this.element.style.webkitTransformOrigin = "0px 0px";
            this.element.style.transform = "scale("+scale+","+scale+")";
            this.element.style.webkitTransform = "scale("+scale+","+scale+")";
        }
    }
}